import './FormActionSelect.scss';

import React from 'react';

import Icon from 'components/Icon';

export default class FormActionSelect extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        disabled: React.PropTypes.bool,
        icon: React.PropTypes.string.isRequired,
        title: React.PropTypes.string.isRequired,
        triggerIcon: React.PropTypes.string.isRequired,
        triggerText: React.PropTypes.string.isRequired
    };

    _handleTriggerClick(event) {
        let target = event.target;

        while(target.getAttribute('class') == null || target.getAttribute('class') !== 'form-action-select__action-menu') {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
    }

    render() {
        let { className, disabled, icon, title, triggerIcon, triggerText } = this.props;
        return (
            <div className={`form-action-select ${className || ''}`}>
                <div>
                    <Icon icon={icon} /> {title}
                </div>
                <div className="form-action-select__action-menu">
                    <button type="button"
                            className="form-action-select__trigger"
                            disabled={disabled != null ? disabled : false}
                            onClick={this._handleTriggerClick.bind(this)}>
                        {triggerText} <Icon icon={triggerIcon} />
                    </button>
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormActionSelect/index.js